import type { BrowserHistory } from 'history';
import type { BrowserQueryString } from '@/scopes/common/infrastructure/query-strings/types';
import { createQueryStringClient } from './queryStringClient';

export const createBrowserQueryString = (initialHistory?: BrowserHistory): BrowserQueryString => {
  const queryStringClient = createQueryStringClient(initialHistory);

  return {
    get: queryStringClient.get,
    set: queryStringClient.set,
  };
};
